<template>
    <div>
        <v-toolbar  color="light-blue lighten-5">
            <v-toolbar-title >Jobs</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid grid-list-lg class="orders-layout">
            <v-row dense>
                <v-col row wrap v-for="(t, index) in cards" :key="`${index}`" cols="12" sm="6" md="4">
                    <v-col cols="12" sm="12" md="12" >
                        <v-card class="mx-auto">
                            <v-toolbar :color=" colorCard(t.travel.idState) ">
                                <v-toolbar-title> Job Id: {{ t.idTravel }}</v-toolbar-title>
                                <v-spacer />
                                <p class="subTitle-car">Status: {{travelStatus(t.travel.idState)}} </p>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <div class="text--primary">
                                        <v-icon class="icon-card">fas fa-calendar-alt</v-icon> Date</div>
                                        <div class="subTitle-card"> {{t.travel.date}} </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <div class="text--primary">
                                        <v-icon class="icon-card">far fa-clock</v-icon> Start Time
                                        </div>
                                        <div class="subTitle-card"> {{t.startTime}} </div>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.description">
                                   <v-icon class="icon-card">fas fa-file-alt</v-icon> Description
                                </div>
                                <div class="subTitle-card"> {{t.travel.travelDetail.description}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary">
                                   <v-icon class="icon-card">fas fa-map-marker-alt</v-icon> Location
                                </div>
                                <div class="subTitle-card"> {{t.travel.location}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary">
                                   <v-icon class="icon-card">fas fa-user-tag</v-icon> Client Name
                                </div>
                                <div class="subTitle-card"> {{t.travel.customer.name}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.po">
                                    <v-icon class="icon-card pt-2 pr-3" >fas fa-hashtag</v-icon> PO
                                </div>
                                <div class="subTitle-card" v-if="t.travel.travelDetail.po"> {{t.travel.travelDetail.po}} </div>
                                <v-divider v-if="t.travel.travelDetail.po"></v-divider>    
                                <div class="text--primary" v-if="t.travel.travelDetail.trucking_Co">
                                    <v-icon class="icon-card pt-3">fas fa-building</v-icon> Trucking CO
                                </div>
                                <div class="subTitle-card" v-if="t.travel.travelDetail.trucking_Co"> {{t.travel.travelDetail.trucking_Co}} </div>
                                <v-divider v-if="t.travel.travelDetail.trucking_Co"></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.truck">
                                    <v-icon class="icon-card pt-2 pr-3">fas fa-truck</v-icon>Truck
                                </div>
                                <div class="subTitle-card" v-if="t.travel.travelDetail.truck"> {{t.travel.travelDetail.truck}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.trailer">
                                    <v-icon class="pt-2 pr-3">fas fa-truck-moving</v-icon>Trailer
                                </div>
                                <div class="subTitle-card" v-if="t.travel.travelDetail.trailer"> {{t.travel.travelDetail.trailer}} </div>
                                <v-divider></v-divider>
                                <div class="text--primary" v-if="t.travel.travelDetail.driver">
                                   <v-icon class="icon-card pt-2"    >fas fa-user</v-icon> Driver
                                </div>
                                <div  class="subTitle-card"> {{t.travel.travelDetail.driver}} </div>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <div class="text-center">
                                    <v-btn class="ma-2" tile outlined color="success" :to="'/kanban/task/'+t.idTravel+'/travelWorker/'+t.idTravelWorker">
                                    Edit<v-icon class="pl-3" left>fas fa-clipboard-check</v-icon>
                                </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                    
                </v-col>
                
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { Component } from 'vue-property-decorator'
    import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
    import ticketBag from './ticketBag.vue'
export default {
    data() {
        return {
            searchText:'',
            cards: [],
            bags:[
                { title: 'To Do', id: 'ToDo', icon: 'assignment', barColor: 'red accent-4', api: 'toDo', progressColor: 'blue-grey', goToLeft: false, goToRight: true, isLoading: false, tickets: { cards: [] } },
                { title: 'Doing', id: 'InProgress', icon: 'account_tree', barColor: 'indigo darken-4', api: 'doing', progressColor: 'deep-orange lighten-2', goToLeft: false, goToRight: false, isLoading: false, tickets: { cards: [] } }
            ]
        }
    },
   
    components:{
        'ticketBag' : ticketBag
    },
    mounted() {
        this.getTickets()
    },
    methods: {
        travelStatus(state){
            let status = state === 1 ? 'Pending' : 'Doing'
            return status;
        },
        colorCard (state) {
            let color = state === 1 ? 'deep-orange lighten-4': 'blue-grey lighten-4'
            return color
        },
        updateKanban() {
            this.getTickets()
        },
        async getTickets(){
            this.bags[0].isLoading=true; this.bags[1].isLoading=true;
            const todo = await this.$store.dispatch('toDo')
            const doing = await this.$store.dispatch('doing')
            if(todo.status === 200 && doing.status === 200){
                this.cards = doing.data.concat(todo.data)
                console.log('cards => ', this.cards)
            }else{
                showMessageError('An error ocurred')
            }
            this.bags[0].isLoading=false; this.bags[1].isLoading=false;
        }
    },
}   
</script>
